import { RequestForCallbackActions } from "./types";

export const sendRequestForCallbackAction = (
  payload: Object
): RequestForCallbackActions => ({
  type: "SEND_REQUEST_FOR_CALLBACK",
  payload,
});

export const sendRequestForCallbackFailed = (): RequestForCallbackActions => ({
  type: "SEND_REQUEST_FOR_CALLBACK_FAILED",
});

export const sendRequestForCallbackSuccess = (): RequestForCallbackActions => ({
  type: "SEND_REQUEST_FOR_CALLBACK_SUCCESS",
});

export const sendRequestForCallbackReset = (): RequestForCallbackActions => ({
  type: "SEND_REQUEST_FOR_CALLBACK_RESET",
});
